import { render, staticRenderFns } from "./KtidStatistics.vue?vue&type=template&id=e5a6defe&"
import script from "./KtidStatistics.vue?vue&type=script&lang=js&"
export * from "./KtidStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports